import { jsx } from "react/jsx-runtime";
import { root } from "./ScreenReaderSkipTarget.css.mjs";
const ScreenReaderSkipTarget = ({ name }) => /* @__PURE__ */ jsx("div", { id: name, tabIndex: -1, className: root });
export {
  ScreenReaderSkipTarget
};
